export default __webpack_public_path__ + "static/media/forgot-password-dark.02a33442.svg";